import { styled } from '@mui/material'

export const AppFooter = styled('footer', { name: 'AppFooter' })({
  display: 'block',
  flex: '0 0 auto',
})
